import React from 'react';

interface AccountSectionProps {
    email: string;
    onChangePassword: () => void;
    onWithdraw: () => void;
}

export const AccountSection: React.FC<AccountSectionProps> = ({
    email,
    onChangePassword,
    onWithdraw
}) => {
    return (
        <div className="profile-section">
            <h2 className="section-title">계정 정보</h2>
            <div className="info-row">
                <span className="info-label">이메일</span>
                <span className="info-value">{email}</span>
            </div>
            <button className="link-button" onClick={onChangePassword}>
                비밀번호 변경
                <span className="arrow">›</span>
            </button>
            <button className="link-button danger" onClick={onWithdraw}>
                회원탈퇴
                <span className="arrow">›</span>
            </button>
        </div>
    );
};
